<template>
    <div class="page_mulu page_shadow">
        <TopHeader :title="'目录'"  :headerLogo="headerLogo"></TopHeader>
        <div class="line_border_title">
            <p>目录<span>Catalog</span></p>
            <p class="line"></p>
        </div>
        <div class="content">
            <div class="content_box" v-for="(item, index) in list">
                <div class="big_title_box" :class="'big_title_box' + (index+1) ">
                    <div class="big_title"> Part.{{index + 1}} {{item.title}}</div>
                </div>
                <template v-for="(child,idx) in item.sTitle">
                    <div class="small_title_box">
                        <div class="small_titled">{{child.s_title}}</div>
                        <div class="line"></div>
                        <div class="page_number"></div>
                    </div>
                    <div class="g_small_title_box" v-for="(g_child,idx) in child.gTitle">
                        <div class="small_titled">{{g_child.g_title}}</div>
                        <div class="line"></div>
                        <div class="page_number"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
export default {
    components: { TopHeader },
    props: ['list','headerLogo'],
    data() {
        return {

        }
    },
    methods: {

    },
    watch: {

    },
    created() {

    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_mulu {
    .big_title_box1, .big_title_box3, .big_title_box5{
        color: #F5A737;
    }
    .big_title_box2, .big_title_box4{
        color: #1CA4B6;
    }

    .color_orange {
        color: #F5A737;
    }
    .color_blue {
        color: #1CA4B6;
    }
    .content {
        .content_box {
            margin-bottom: 30px;
        }
    }
    .big_title_box {
        margin-bottom: 10px;
        .big_title {
            position: relative;
            font-size: 20px;
            font-weight: bold;
            line-height: 30px;
        }
    }
    .small_title_box {
        font-size: 16px;
        color: #333;
        line-height: 38px;
        display: flex;
        .small_titled {
            padding-right: 20px;
            font-weight: bold;
        }
        .line {
            flex: 1;
            border-top: 2px dotted #333;
            margin: auto 0;
        }
        .page_number {
            padding-left: 10px;
            font-size: 18px;
        }
    }
    .g_small_title_box {
        .small_title_box;
        font-weight: normal;
        color: #8A8A8A;
        line-height: 40px;
        .small_titled {
            padding-right: 20px;
            font-size: 16px;
            text-indent: 2em;
            font-weight: normal;
        }
        .line {
            border-top: 2px dotted #8A8A8A;
        }
        .page_number {
            font-size: 14px;
        }
    }
}
</style>